
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.673 24.01a.75.75 0 01-.381-.104l-2.961-1.753c-.019-.011-.036-.023-.053-.035a2.475 2.475 0 01-1.006-2.338v-1.457l-.887-.887a2.066 2.066 0 01-.608-1.467 2.066 2.066 0 011.745-2.046V4.511h-4.5a.75.75 0 01-.75-.75c0-1.241-1.009-2.25-2.25-2.25s-2.25 1.009-2.25 2.25a.75.75 0 01-.75.75h-4.5v9.749a.75.75 0 01-1.5 0V4.511c0-.827.673-1.5 1.5-1.5h3.825c.35-1.732 1.875-3 3.675-3 1.8 0 3.324 1.268 3.675 3h3.825c.827 0 1.5.673 1.5 1.5v4.551l3.909 3.459c.043.038.081.08.114.126.639.895.978 1.951.978 3.052v2.181c0 .43.168.835.472 1.14l.286.286a.752.752 0 01-.53 1.281.743.743 0 01-.53-.22l-.286-.286a3.093 3.093 0 01-.912-2.2V15.7c0-.759-.225-1.489-.652-2.113l-2.848-2.521v3.192c.11.073.208.153.297.242l1.56 1.561c.142.142.22.33.22.53a.746.746 0 01-1.28.53l-1.56-1.561a.575.575 0 00-.813.814l1.107 1.107c.14.14.22.333.22.53v1.824a.729.729 0 01-.01.123.962.962 0 00.365.921l2.929 1.734a.751.751 0 01-.385 1.397z"}}),_c('path',{attrs:{"d":"M8.563 24.01a.752.752 0 01-.582-1.224l2.426-2.982a.517.517 0 00-.067-.719.452.452 0 00-.635.048l-.014.018a.789.789 0 01-.095.098l-.838.717a.752.752 0 01-1.238-.57V13.51a.75.75 0 00-1.5 0v3.75a.75.75 0 01-.75.75H4.032a2.55 2.55 0 00-2.511 2.575v2.674a.75.75 0 01-1.5 0v-2.667a4.054 4.054 0 014.002-4.082h.498v-3c0-1.241 1.009-2.25 2.25-2.25s2.25 1.009 2.25 2.25v4.259a1.952 1.952 0 012.298.18c.831.717.943 1.947.253 2.8l-2.428 2.984a.743.743 0 01-.581.277zM9.021 4.886a1.127 1.127 0 01-.798-1.919 1.128 1.128 0 011.923.794c0 .62-.504 1.125-1.125 1.125z"}})])
          )
        }
      }
    